import { configureStore } from "@reduxjs/toolkit";
import aboutSlice from "./about-store";
import addressSlice from "./address-store";
import cartSlice from "./cart-store";
import contactSlice from "./contact-store";
import checkoutSectionSlice from "./checkout-section-store";
import faqSlice from "./faq-store";
import favoritesSlice from "./favorites-store";
import generalSlice from "./general-store";
import productDetailSlice from "./product-detail-store";
import shopItemsSlice from "./shop-store";
import { CART_STORAGE_KEY } from "./cart-store";

const store = configureStore({
  reducer: {
    about: aboutSlice.reducer,
    address: addressSlice.reducer,
    cart: cartSlice.reducer,
    checkoutSection: checkoutSectionSlice.reducer,
    contact: contactSlice.reducer,
    faqs: faqSlice.reducer,
    favorites: favoritesSlice.reducer,
    general: generalSlice.reducer,
    products: shopItemsSlice.reducer,
    productDetail: productDetailSlice.reducer,
  },
});

let previousCartState;
store.subscribe(() => {
  const currentCartState = store.getState().cart.cartData;
  const serializedCart = JSON.stringify(currentCartState);

  if (serializedCart === previousCartState) {
    return;
  }

  previousCartState = serializedCart;

  if (typeof window !== "undefined") {
    localStorage.setItem(CART_STORAGE_KEY, serializedCart);
    localStorage.setItem("cart-items", JSON.stringify(currentCartState.items));
  }
});

export default store;
